module.exports = __webpack_public_path__ + "02_short_gray.1b123fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_short_gray.png
// module id = wby+
// module chunks = 0